import { ProgramStatus, ProgramMetadataModel } from '../common';

export enum USAAParamType {
  'AccountManagement' = 'AccountManagement',
  'PreSelect' = 'PreSelect',
}

export interface USAAParameters {
  type?: USAAParamType;
  runType: string;
  strategy: string;
  serJsonDate: string;
  samplePercentage: string;
  executionDate: string;
  BureauCallIndicator?: string | null;
  SerJsonValidate?: string | null;
  executeOnDemand?: string | null;
  consolidatedInputFileDate?: string | null;
  bureauFileDate?: string | null;
  generateArtifacts?: string | null;
  spcFlag?: string | null;
  marketSwitchFlag?: string | null;
}

export interface USAAProductInputModel {
  productDetails: USAAProductDetailsModel;
}

export interface USAAPackagesInputModel {
  parameters: USAAParameters;
}

export interface AscendUSAAProgram {
  status?: ProgramStatus;
  externalSystemRef?: string;
  subCode?: string;
  programKey?: string;
  metadata: ProgramMetadataModel;
  productInput: USAAProductInputModel;
  packagesInput: USAAPackagesInputModel;
  dataDictionaryVersion?: string;
  loginType?: string;
}

export interface USAAProductDetailsModel {
  programName: string;
  userId: string;
  clientName: string;
  clientEmail: string;
  submitterName: string;
  submitterEmail: string;
}
